import React, { Component } from 'react'
import DefaultPage from '../../Container/Layout/DefaultPage'
//import { listenCanidateConfirmedEvents } from '../../firebase/database/handleEvents'

class CanidateConfirmedEvents_ extends Component {
    
    componentDidMount () {

    }

    handleClick = () => {
       // const userId = 'HtAoqZ1LpTbTW0ZeeSgXvTfg54R2'
        
    }
    

    render () {
        const defaultPage = {
            headlineText: 'Angenommene Hilfegesuche',
            headlineSubtext: 'Daten werden geladen.....'
        }
        return (
            <DefaultPage headline={defaultPage} >
            <button onClick={this.handleClick}> Click </button>
            </DefaultPage>
        )
    }
}


export default CanidateConfirmedEvents_


// WEBPACK FOOTER //
// ./src/Components/Canidates/CanidateConfirmedList.js